var SliderScript = (function($){

    var Init = function(){
      // Slider
      var swiper = new Swiper('.swiper-container', {
          pagination: '.swiper-pagination',
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev',
          slidesPerView: 'auto',
          centeredSlides: false,
          paginationClickable: true,
          spaceBetween: 30,
          freeMode: true,
          loop: false
      });
    };

    // "public" methods
    return {
        Init : Init
    };

})(jQuery);
